<template>
    <div >
        <vapp-header btnMenu btnSearch :tabList="tabItem"></vapp-header>

        <div class="list-group-fnc" v-if="searchIsActive">
            <div class="search-result" v-if="invoice_search_result.length && invoice_search_query.length">
                {{ invoice_search_result.length }} <span v-if="invoice_search_result.length > 1">results</span><span v-else>result</span> found
            </div>
            <div class="search-error" v-else-if="!invoice_search_result.length && invoice_search_query.length">
                No result found. Check your spelling and try again.
                <div class="quote">
                    <blockquote>
                        "Not all those who wander are lost" - J.R.R Tolkien
                    </blockquote>
                </div>

            </div>
            <div class="" v-else-if="!invoice_search_result.length && !invoice_search_query.length">
                <b-list-group class="search-suggestion shadow">
                    <b-list-group-item class="border-0"><span>Suggested Search</span></b-list-group-item>
                    <b-list-group-item class="border-0" @click="updateInvoiceSearchQuery(1)">Customers <hr class="black-underline"/></b-list-group-item>
                    <b-list-group-item class="border-0" @click="updateInvoiceSearchQuery(2)">Contacts <hr class="black-underline"/></b-list-group-item>
                    <b-list-group-item class="border-0" @click="updateInvoiceSearchQuery(3)">Items</b-list-group-item>
                </b-list-group>
            </div>
            <div v-for="(invoice, index) in invoice_search_result" :key="index" class="row no-gutters flex-nowrap p-3" @click="editInvoice(invoice)">
                <img class="pr-4 img-placeholder" src="@/assets/images/inv-icon-unpaid.svg">
                <div class="d-flex flex-column flex-grow-1">
                    <div class="d-flex justify-content-between">
                        <h5 class="mb-1 font-weight-bold">{{ invoice.contact_name }}</h5>
                        <h5 class="font-weight-bold text-green">{{ currency_symbol }} {{ $numberWithCommas(invoice.amount) }}</h5>
                    </div>
                    <h5 class="mb-1 text-gray">{{ invoice.no }}</h5>
                    <h5 class="mb-1 text-red" v-if="invoice.due_date">Due on {{ invoice.due_date | moment("DD/MM/YYYY") }}, {{ invoice.due_date | moment("from") }}</h5>
                </div>
            </div>

        </div>
        <div class="list-group-fnc" v-else-if="invoices.length">
            <div v-for="(invoice, index) in sorted_invoices" :key="index" class="row no-gutters flex-nowrap p-3" @click="editInvoice(invoice)">
                <img class="pr-4 img-placeholder" src="@/assets/images/inv-icon-unpaid.svg">
                <div class="d-flex flex-column flex-grow-1">
                    <div class="d-flex justify-content-between">
                        <h5 class="mb-1 font-weight-bold">{{ invoice.contact_name }}</h5>
                        <h5 class="font-weight-bold text-green">{{ invoice.currency.symbol }} {{ $numberWithCommas(invoice.amount) }}</h5>
                    </div>
                    <div class="d-flex justify-content-between">
                        <h5 class="mb-1 text-gray">{{ invoice.no }}</h5>
                        <h5 class="font-weight text-gray" v-if="invoice.currency_rate !== 1"><i>{{ base_currency.symbol }} {{ $numberWithCommas(invoice.amount * invoice.currency_rate) }}</i></h5>
                    </div>
                    <h5 class="mb-1 text-red" v-if="invoice.due_date && invoice.due_date !== '0000-00-00'">Due on {{ invoice.due_date | moment("DD/MM/YYYY") }}, {{ invoice.due_date | moment("from") }}</h5>
                </div>
            </div>
            <!--<div class="bottomSpace"></div>-->
            <infinite-loading @infinite="infiniteHandler"></infinite-loading>


        </div>
        <div v-else-if="invoices.length === 0 && is_loading_api === false">
            <md-empty-state class="empty-state" v-if="!num_invoices && current_route_param === 'all'">
                <h1>Let's create your first invoice!</h1>
                <p>Create new invoice by clicking this button</p>
                <img src="@/assets/images/ic_arrow_point.svg">
            </md-empty-state>
            <md-empty-state class="empty-state" v-else-if="!num_invoices && current_route_param === 'unpaid'">
                <h1>No unpaid invoices!</h1>
                <p>Create new invoice by clicking this button</p>
                <img src="@/assets/images/ic_arrow_point.svg">
            </md-empty-state>
            <md-empty-state class="empty-state" v-else-if="!num_invoices && current_route_param === 'draft'">
                <h1>No draft invoices</h1>
                <p>Create new invoice by clicking this button</p>
                <img src="@/assets/images/ic_arrow_point.svg">
            </md-empty-state>

        </div>

        <vapp-right-panel :thepage="'/create_invoice'"></vapp-right-panel>

    </div>

</template>

<script>
    import { mapState, mapActions} from 'vuex';
    import invoiceService from "../../services/invoiceService";
    import * as $$ from "lodash";

    export default {
        data: function() {
            return {
                invoices: [],
                all_invoices: [],
                all_unpaid: [],
                all_draft: [],
                company_id: null,
                current_date: this.$moment().format("YYYY-MM-DD"),
                tabItem: {
                    name: 'invoice',
                    params: ['all', 'unpaid', 'draft']
                },
                base_currency: null,
                is_loading_api: false,
                page : 1,

            }
        },
        computed: {
            // ...mapState([
            //     'user',
            //     'selectedContact',
            //     'selectedDepositToContact',
            //     'items',
            //     'invoice_title',
            //     'invoice_number',
            //     'invoice_memo',
            //     'invoice_being_edited',
            //     'searchIsActive',
            //     'invoice_search_result',
            //     'invoice_search_query',
            // ]),
            ...mapState('global',['searchIsActive',]),
            ...mapState('company',['selectedCompany']),
            sorted_invoices: function() {
                return _.orderBy(this.invoices, 'id', 'desc')
            },
            num_invoices: function() {
                return this.invoices.length
            },
            current_route_param: function() {
                return this.$route.params.cat
            },
        },
        mounted() {
            console.log("Mounted : Main Invoice");

            this.clearDatas();
            
            invoiceService.methods.getInvoices(this.selectedCompany)
                .then(data => {
                    this.all_invoices = data.transactions;
                    this.base_currency = data.meta.base_currency


                    $$.each(this.all_invoices, (invoice) => {
                        if (invoice.status === 0) {
                            this.all_draft.push(invoice)
                        } else if (invoice.balance > 0) {
                            this.all_unpaid.push(invoice)
                        }
                    });

                    this.invoices = this.all_invoices;
                    this.switchTab();
                });
        },
        methods: {
            ...mapActions('global', [
                'setSearchActive', 
                'clearInvoiceSearchResult', 
                'clearInvoiceSearchQuery', 
            ]),
            ...mapActions('invoice', [
                'clearInvoiceDetails',
                'setInvoiceMemo',
                'clearItems', 
                'clearPayments', 
                'clearSelectedContact', 
                'clearSelectedDepositToContact', 
                'clearInvoiceMemo', 
                'clearInvoiceObj',
                'setSelectedContact',
                'setDepositContact',
                'pushItem',
                'pushPayment',
                'setEditInvoiceObj',
                'setIsEditingInvoice'
            ]),
            infiniteHandler($state) {
                this.page += 1;
                this.$root.$emit('show-loading', true);
                this.axios.get("sales?entity_id=" + this.selectedCompany + "&type=SALE_INVOICE&page=" + this.page)
                    .then(({ data }) => {
                        this.$root.$emit('show-loading', false);
                        if (data.transactions.length) {

                            let tempTransaction = data.transactions;

                            $$.each(tempTransaction, (tempTxn) => {
                                 this.all_invoices.push(tempTxn);
                            });

                            $$.each(this.all_invoices, (invoice) => {
                                if (invoice.status === 0) {
                                    this.all_draft = [];
                                    this.all_draft.push(invoice)
                                } else if (invoice.status === 1) {
                                    this.all_unpaid = [];
                                    this.all_unpaid.push(invoice)
                                }
                            });
                            this.invoices = [];
                            this.invoices = this.all_invoices;
                            $state.loaded();
                        } else {
                            $state.complete();
                        }
                    })
                    .catch(error => {
                        this.$root.$emit('show-loading', false);
                        this.$generalAPIErrorHandling(error, this.$router);
                    });
            },

            clearDatas () {
                this.clearInvoiceSearchResult();
                this.clearInvoiceSearchQuery();
                this.clearItems();
                this.clearPayments();
                this.clearSelectedContact();
                this.clearSelectedDepositToContact();
                this.clearInvoiceMemo();
                this.clearInvoiceObj();
            },
            switchTab() {
                if (this.$route.params.cat === 'all') {
                    this.invoices = this.all_invoices;
                } else if (this.$route.params.cat === 'unpaid') {
                    this.invoices = this.all_unpaid;
                } else if (this.$route.params.cat === 'draft') {
                    this.invoices = this.all_draft
                }
            },
            editInvoice(invoice) {
                this.setEditInvoiceObj(invoice);
                this.setIsEditingInvoice(true);
                this.$router.push({ name: 'edit_invoice', params: { id: invoice.id } })
            },
            updateInvoiceSearchQuery(query) {
                switch (query) {
                    case 1:
                        this.$root.$emit('update-invoice-search-query', "Customers");
                        break;
                    case 2:
                        this.$root.$emit('update-invoice-search-query', "Contacts");
                        break;
                    case 3:
                        this.$root.$emit('update-invoice-search-query', "Items");
                        break;
                }
            },
        },
        watch: {
            '$route': 'switchTab'
        },
        created() {
            this.setSearchActive();
        },
    }
</script>

<style lang="scss" scoped>
    .ad {
        border-bottom: 8px solid #0f3827;
    }

    .invoice-menu {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 1500;
        background-color: white;
        .menu-header {
            background-color: grey;
            padding: 25px;
            border-bottom: 1px solid rgba(0,0,0,0.1);
            span {
                button{
                    margin-top: -8px !important;
                    margin-left: 0 !important;
                    margin-right: 0 !important;
                }
            }
        }
    }

    .search-suggestion {
        margin: 10px;
        border: 1px solid #c7c7c7;

        hr.black-underline {
            border-color: black;
        }

        hr {
            margin-bottom: 0px !important;
        }
    }

    .list-group-item:last-child {
        margin-bottom: 5px !important;
    }

    .search-suggestion span {
        font-weight: bolder !important;
    }
</style>
